<template>
  <div>
    <div
      class="mdgridviewpage-bg mainWrap-bg applicationListPage indicatorPage"
    >
      <!-- <HeaderNew></HeaderNew> -->
      <div class="container-fluid maindivWrap pt-4">
        <div class="row">
          <div class="col-12">
            <div class="row mx-0">
              
              <div class="col-12 px-0">
                <div class="row mx-0">
                  <div class="col-4 px-0">
                    <form>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fa fa-search" aria-hidden="true"></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Search..."
                          id
                          name
                          v-model="searchName"
                          style="border-left: 0"
                        />
                      </div>
                    </form>
                  </div>
                  <div class="col-8 px-0">
                    <div class="d-flex" style="justify-content: flex-end">
                      <div class="mx-2">
                        <form class="form-inline" action="/action_page.php">
                          <label for="" class="mr-sm-2">Show:</label>
                          <select
                            class="form-control"
                            id="sel1"
                            v-model="perPage"
                          >
                            <option>10</option>
                            <option>50</option>
                            <option>100</option>
                            <option>500</option>
                          </select>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="listingTable mb-4">
              <div class="row mx-0">
                <div class="col-12 px-0">
                  <div class="row">
                    <div class="col-6">
                      <h5 class="section_title mt-3">Indicator Type</h5>
                    </div>
                    <div class="col-6">
                      <button
                        class="btn btn-sm float-right addTemp_btn mt-3 mr-0"
                        data-toggle="collapse"
                        href="#add_indicator_type"
                        @click="edittableforflage()"
                      >
                        <span class="border_bottom_grey">
                          <i class="fa fa-plus" aria-hidden="true"></i> Add
                          Indicator Type
                        </span>
                      </button>
                    </div>
                  </div>
                  <div class="card tableCard">
                    <div class="card-body px-0 pt-2">
                      <table
                        class="table table-striped table-hover mb-0 bg-white" style="border-radius: 10px;box-shadow: 0px 0px 2px #ddd;"
                      >
                        <thead>
                          <tr class="row mx-0" style="border-radius: 10px 10px 0 0;">
                            <th class="col-1" style="border-top: 0">No.</th>
                            <th class="col-4" style="border-top: 0">
                              Indicator Name
                            </th>
                            <th class="col-2" style="border-top: 0">Factor</th>
                            <th
                              class="col-3 sortIconAfter"
                              style="border-top: 0"
                            >
                              Updated On
                              <img
                                src="../assets/img/icons/sort_svg.svg"
                                class=""
                              />
                            </th>
                            <th class="col-2" style="border-top: 0">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            class="row mx-0"
                            v-for="(item, index) in typeList"
                          >
                            <td class="col-1">{{ index + 1 }}</td>
                            <td class="col-4">{{ item.displayName }}</td>
                            <td class="col-2">{{ item.factor }}</td>
                            <td class="col-3">{{ item.lastUpdated }}</td>
                            <td class="col-2">
                              <div class="iconGroup">
                                <i
                                  class="fa fa-pencil-square-o cursor-pointer"
                                  aria-hidden="true"
                                  v-b-tooltip.hover
                                  title="Edit"
                                  data-toggle="collapse"
                                  href="#add_indicator_type"
                                  @click="
                                    edittabledata(indicatortablevalue[index])
                                  "
                                ></i>
                                <i
                                  class="fa fa-trash cursor-pointer"
                                  aria-hidden="true"
                                  v-b-tooltip.hover
                                  title="Delete"
                                  @click="
                                    deletetabledata(indicatortablevalue[index])
                                  "
                                ></i>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="mt-3" v-if="typeList.length > 0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="allTypeListLen"
                      :per-page="perPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                      align="center"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="wizardCard mb-4 collapse" id="add_indicator_type">
              <div class="card shadow-sm">
                <div class="card-header">Add Indicator Type</div>
                <div class="card-body">
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-3 col-form-label"
                          >Indicator Type Name</label
                        >
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            v-model="indicatortypenamevalue"
                            id="indicatorTypeName"
                            placeholder
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="col-sm-12 mb-1">
                      <div class="form-group row mx-0">
                        <label
                          for="indicatorTypeName"
                          class="col-sm-3 col-form-label"
                          >Factor</label
                        >
                        <div class="col-sm-9">
                          <input
                            type="text"
                            class="form-control"
                            v-model="indicatorfactor"
                            id="indicatorTypeName"
                            placeholder
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0 mb-2">
                    <div class="justify-content-end d-flex w-100">
                      <button
                        class="btn btn-newprimary"
                        v-if="updatetableflag == false"
                        @click="
                          indicatortype(indicatortypenamevalue, indicatorfactor)
                        "
                      >
                        Save
                      </button>
                      <button
                        class="btn btn-success text-white"
                        v-if="updatetableflagfor1entry == true"
                        @click="
                          indicatortypeupdate(
                            indicatortypenamevalue,
                            indicatorfactor
                          )
                        "
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-12">
            <div class="bottomSubmitbtn float-right mb-4">
              <button class="btn btn-newprimary">
                Next
                <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- <training-footer></training-footer> -->
  </div>
</template>
<script>
import HeaderNew from "../components/layout/HeaderNew";
import trainingFooter from "../components/trainingFooter";
import ApiServices from "../service/ApiServices";
export default {
  components: {
    HeaderNew,
    trainingFooter,
  },
  data() {
    return {
      userProfile: "",
      indicatortablevalue: [],
      allTypeListLen: "",
      indicatortypenamevalue: "",
      indicatorfactor: "",
      editabledata: [],
      updatetableflag: false,
      updatetableflagfor1entry: false,
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      options: [
        { value: null, text: "Please select an option", disabled: true },
        { value: "5", text: "5" },
        { value: "25", text: "25" },
        { value: "50", text: "50" },
        { value: "100", text: "100" },
      ],
      perPage: 10,
      currentPage: 1,
      allAppsList: [],
      searchName: "",
      isView: "list",
      allAppsListLen: 0,
    };
  },
  computed: {
    typeList() {
      let filteredApps = this.indicatortablevalue.filter((a) => {
        //console.log(a)
        a.displayName = a.displayName.toString();
        return (
          (a.displayName &&
            a.displayName
              .toLowerCase()
              .includes(this.searchName.toLowerCase())) ||
          (a.displayName &&
            a.displayName.includes(this.searchName.toLowerCase()))
        );
      });

      // console.log("filteredApps",filteredApps)
      this.allTypeListLen = filteredApps.length;
      return filteredApps.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    rows() {
      return this.allAppsList.length;
    },
  },
  methods: {
    edittableforflage() {
      this.updatetableflag = false;
      this.updatetableflagfor1entry = false;
      this.indicatortypenamevalue = "";
      this.indicatorfactor = "";
    },
    gotoApp(appId, appUserId) {
      window.open(
        `http://localhost:8080/#/?appId=${appId}&appUserId=${appUserId}`,
        "_blank"
      );
    },
    edittabledata(data) {
      console.log(data);
      this.updatetableflagfor1entry = true;
      this.updatetableflag = true;
      this.indicatortypenamevalue = data.displayName;
      this.indicatorfactor = data.factor;
      this.editabledata = data;
    },
    deletetabledata(data) {
      console.log(data);

      ApiServices.RestDeleteCall("api/indicatorTypes/" + data.id).then(
        (res) => {
          console.log(res);
          this.$router.go();
        }
      );
    },
    indicatortypeupdate(name, factor) {
      console.log(name, factor);
      console.log(this.editabledata);

      var obj = {
        created: this.editabledata.created,
        lastUpdated: this.editabledata.lastUpdated,
        number: false,
        name: name,
        id: this.editabledata.id,
        factor: factor,
        lastUpdatedBy: { id: this.editabledata.id },
        translations: [],
      };

      ApiServices.RestPutCall(
        "api/indicatorTypes/" + this.editabledata.id + "?mergeMode=REPLACE",
        obj
      ).then((res) => {
        console.log(res);
        this.$router.go();
      });
    },
    indicatortype(name, factor) {
      console.log(name, factor);

      ApiServices.RestPostCall("api/indicatorTypes", {
        name: name,
        factor: factor,
      }).then((res) => {
        console.log(res);
        this.$router.go();
      });
    },
    logout() {
      //dhis-web-commons-security/logout.action
      localStorage.removeItem("userProfile");
      localStorage.removeItem("loggedInUserId");
      ApiServices.RestGetCall(
        "dhis-web-commons-security/logout.action",
        {}
      ).then((res) => {
        console.log(res);
      });
      //window.open('http://intraavenir.duredemos.com/service/dhis-web-commons-security/logout.action', '_blank');
      this.$router.push("/");
    },
    getAllApps() {
      console.log(this.$root);
      this.$root.loading = true;
      ApiServices.getAllKeys()
        .then(async (response) => {
          console.log(response);
          let filteredApps = [];

          response.data.forEach((a) => {
            let keyName = a.split("_");
            if (a.includes("applicationModule") && keyName.includes("en")) {
              filteredApps.push(a);
            }
          });

          await ApiServices.RestGetCall(
            "/api/avenir/training/getTrainingApps"
          ).then((response) => {
            console.log("Training response", response.trainingApp);
            response.trainingApp.forEach((t) => {
              this.allAppsList.push(t);
            });
          });
          if (filteredApps.length) {
            filteredApps.forEach(async (f, i) => {
              let appResponse = await ApiServices.getSavedConfig(f);
              this.allAppsList.push(appResponse.data);
              if (this.allAppsList.length === filteredApps.length) {
                this.$root.loading = false;
                console.log("apps List", this.allAppsList);
              }
            });
          }
        })
        .catch((res) => (this.$root.loading = false));
    },
  },
  mounted() {
    this.userProfile = JSON.parse(localStorage.getItem("userProfile"));
    this.baseUrl = ApiServices.getBaseUrl();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;
    //this.getAllApps();
    ApiServices.RestGetCall(
      "api/indicatorTypes?filter=name:ne:default&fields=displayName%2CshortName%2Cid%2ClastUpdated%2Ccreated%2CdisplayDescription%2Ccode%2CpublicAccess%2Caccess%2Chref%2Clevel%2CdisplayName%2Cfactor%2CpublicAccess%2ClastUpdated%2C&order=displayName%3AASC",
      {}
    ).then((res) => {
      console.log(res);
      this.indicatortablevalue = res.indicatorTypes;
    });
  },
};
</script>
<style scoped lang="scss">
.mainWrap-bg {
  background-color: #f4f4f4 !important;
  background-image: none;
  /* background-size: cover;
  background-position: center; */
  min-height: 100vh;
  padding: 10px 20px;
}
.maindivWrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.form-control {
  background-color: transparent !important;
}
.tableCard {
  .table {
    thead {
      tr {
        background: #2e3f53;
        th {
          color: #fff;
        }
      }
    }
  }
}
table tbody {
  border-radius: 0px 0px 10px 10px;
}
table tbody tr:last-child td:nth-last-child(1) {
  border-radius: 0px 0px 10px 0px;
}
table tbody tr:last-child td:nth-last-child(4) {
  border-radius: 0px 0px 0px 10px;
}

</style>
